import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const AppContext = createContext(null);

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
};

export const AppProvider = ({ children }) => {
  // Language: default NL
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("smp-lang") || "nl";
  });

  // Theme: default dark
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("smp-theme") || "dark";
  });

  // Terms of sale modal
  const [termsOpen, setTermsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("smp-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem("smp-theme", theme);
  }, [theme]);

  const toggleLang = useCallback(() => {
    setLang((prev) => (prev === "nl" ? "en" : "nl"));
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  }, []);

  const t = translations[lang];

  return (
    <AppContext.Provider
      value={{ lang, setLang, toggleLang, theme, toggleTheme, t, termsOpen, setTermsOpen }}
    >
      {children}
    </AppContext.Provider>
  );
};
